import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalInsuredInterestName: {
        id: 'additionalinterest.Common.Name',
        defaultMessage: 'Name',
    },
    additionalInsuredType: {
        id: 'additionalinterest.Common.Relationship To Primary Named Insured',
        defaultMessage: 'Relationship To Primary Named Insured',
    },
    additionalInterestType: {
        id: 'additionalinterest.Common.Interest Type',
        defaultMessage: 'Interest Type',
    },
    additionalType: {
        id: 'additionalinterest.Common.AdditionalType',
        defaultMessage: 'Type',
    },
    additionalInsureds: {
        id: 'additionalinterest.Common.Additional Insureds',
        defaultMessage: 'Additional Insureds',
    },
    additionalInsured: {
        id: 'additionalinterest.Common.Additional Insured',
        defaultMessage: 'Additional Insured',
    },
    additionalNamedInsureds: {
        id: 'additionalinterest.Common.Additional Named Insureds',
        defaultMessage: 'Additional Named Insureds',
    },
    additionalNamedInsured: {
        id: 'additionalinterest.Common.Additional Named Insured',
        defaultMessage: 'Additional Named Insured',
    },
    anotherAdditionalInsured: {
        id: 'additionalinterest.Common.Add Another Additional Insured',
        defaultMessage: 'Add Another Additional Insured?',
    },
    anotherAdditionalNamedInsured: {
        id: 'additionalinterest.Common.Add Another Additional Named Insured',
        defaultMessage: 'Add Another Additional Named Insured?',
    },
    additionalInterests: {
        id: 'additionalinterest.Common.Additional Interests',
        defaultMessage: 'Additional Interests',
    },
    additionalInterest: {
        id: 'additionalinterest.Common.Additional Interest',
        defaultMessage: 'Additional Interest',
    },
    anotherAdditionalInterest: {
        id: 'additionalinterest.Common.Add Another Additional Interest',
        defaultMessage: 'Add Another Additional Interest?',
    },
    additionalInterestName: {
        id: 'additionalinterest.Common.Name',
        defaultMessage: 'Name',
    },
    additionalInterestSave: {
        id: 'additionalinterest.Common.Save',
        defaultMessage: 'Save',
    },
    additionalInterestCancel: {
        id: 'additionalinterest.Common.Cancel',
        defaultMessage: 'Cancel',
    },
    primaryNumber: {
        id: 'additionalinterest.Common.contact-phone-details.Primary number',
        defaultMessage: 'Primary number',
    },
    description: {
        id: 'additionalinterest.Common.contact-phone-details.Description',
        defaultMessage: 'Description',
    },
     removeInfo: {
        id: 'quoteandbind.Common.templates.Remove Massage Therapist',
        defaultMessage: 'Remove Additional Interest',
    },
    removeInfoDesc: {
        id: 'quoteandbind.Common.templates.MassageInfo',
        defaultMessage: 'Are you sure you want to remove this Additional Interest from the list?',
    },
});
